import { TFunction } from "i18next";
import * as yup from "yup";

export const cameraCheckValidation = (
  t: TFunction,
  commentRequired: boolean
) => {
  return yup.object().shape({
    // Text inputs
    ...(commentRequired
      ? {
          ...["comment"].reduce(
            (acc, el) => ({
              ...acc,
              [el]: yup
                .string()
                .required(t("validation.required"))
                .max(250, t("validation.more250")),
            }),
            {}
          ),
        }
      : {}),

    // Select inputs
    ...["status"]
      .filter((el) => !!el)
      .reduce(
        (acc, el) => ({
          ...acc,
          [el]: yup.object().shape({
            value: yup
              .string()
              .nullable()
              .required(t("validation.required"))
              .matches(/^((?!Не выбрано|Not chosen).)*$/g),
          }),
        }),
        {}
      ),
  });
};
